export class FunctionsService {

    static removeHTMLTags(html) {
        html = html.replace(/&(lt|gt);/g, function (strMatch, p1) {
            return (p1 == "lt") ? "<" : ">";
        });
        var text = html.replace(/<\/?[^>]+(>|$)/g, "");
        return text;
    }

    static firstParagraph(html) {
        var text = '';
        var data = [];

        if (html) {
            text = this.removeHTMLTags(html);

            data = text.split('.');
            if (data.length > 1) {
                text = data[0] + '.';
            }

            data = text.split('?');
            if (data.length > 1) {
                text = data[0] + '?';
            }

            data = text.split('!');
            if (data.length > 1) {
                text = data[0] + '!';
            }
        }
        return text;
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/services/functions.service.ts